// extracted by mini-css-extract-plugin
module.exports = {"icon":"IconSuccess_icon__3iAgI","fadein":"IconSuccess_fadein__1Ktf4"};